import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/svg/close.svg'
import _imports_1 from '@/assets/icons/svg/speaker-off.svg'
import _imports_2 from '@/assets/icons/svg/speaker.svg'


const _withScopeId = n => (_pushScopeId("data-v-3dd469c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full relative" }
const _hoisted_2 = { class: "absolute top-0 right-0 z-10" }
const _hoisted_3 = { class: "flex flex-row p-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: _imports_0,
  alt: "close"
}, null, -1 /* HOISTED */))
const _hoisted_5 = {
  key: 3,
  class: "relative w-full h-full flex flex-col justify-center items-center",
  style: {"background-color":"#1953b9"}
}
const _hoisted_6 = { class: "absolute w-full h-full flex flex-col items-center" }
const _hoisted_7 = { class: "text-5xl text-white p-20 w-full h-1/3 text-center" }
const _hoisted_8 = { class: "flex flex-col flex-grow justify-end p-8" }
const _hoisted_9 = { class: "flex flex-col place-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "w-6 h-6",
  src: _imports_1,
  alt: "close"
}
const _hoisted_11 = {
  key: 1,
  class: "w-6 h-6",
  src: _imports_2,
  alt: "close"
}
const _hoisted_12 = {
  key: 5,
  class: "relative w-full h-full flex flex-col justify-center items-center",
  style: {"background-color":"#ff8ab7"}
}
const _hoisted_13 = { class: "absolute w-full h-full flex flex-col items-center" }
const _hoisted_14 = { class: "text-5xl text-white p-20 w-full h-1/3 text-center" }
const _hoisted_15 = { class: "flex flex-col flex-grow justify-end p-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Intro = _resolveComponent("Intro")!
  const _component_PlayersReady = _resolveComponent("PlayersReady")!
  const _component_PlayerReady = _resolveComponent("PlayerReady")!
  const _component_ChaosQuizz = _resolveComponent("ChaosQuizz")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.mode !== _ctx.MODES.quizzIntro && _ctx.mode !== _ctx.MODES.finished)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.players, (p) => {
              return (_openBlock(), _createBlock(_component_Avatar, {
                key: p._id,
                layout: p.profile.avatar,
                class: "w-24 h-24 -mr-6"
              }, null, 8 /* PROPS */, ["layout"]))
            }), 128 /* KEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Button, {
          class: "pointer-events-auto ml-6 bg-white m-6",
          childclass: 'w-12 h-12',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.finish()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        (_ctx.mode === _ctx.MODES.intro)
          ? (_openBlock(), _createBlock(_component_Intro, {
              key: 0,
              title: _ctx.t('title'),
              description: _ctx.t('description'),
              "exercise-index": _ctx.exerciseIndex,
              image: _ctx.chaosImage
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  backgroundcolour: 'bg-sl-green-button',
                  textcolour: 'text-white',
                  childclass: 'text-2xl border-none h-16 p-4 inline-block',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMode(_ctx.MODES.changePlayer)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('getStarted')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "description", "exercise-index", "image"]))
          : (_ctx.mode === _ctx.MODES.playersReady)
            ? (_openBlock(), _createBlock(_component_PlayersReady, {
                key: 1,
                description: _ctx.t('yourTurn'),
                players: _ctx.players
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    backgroundcolour: 'bg-sl-green-button',
                    textcolour: 'text-white',
                    childclass: 'text-2xl border-none h-16 w-56',
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeMode(_ctx.MODES.changePlayer)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('weReady')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["description", "players"]))
            : (_ctx.mode === _ctx.MODES.playerReady && _ctx.currentPlayer)
              ? (_openBlock(), _createBlock(_component_PlayerReady, {
                  key: 2,
                  description: _ctx.t('yourTurn'),
                  playerwordlist: _ctx.currentPlayer,
                  onPlaywordagain: _ctx.playWordAgain
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      backgroundcolour: 'bg-sl-green-button',
                      textcolour: 'text-white',
                      childclass: 'text-2xl border-none h-16 w-56',
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeMode(_ctx.MODES.changePlayer)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('next')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["description", "playerwordlist", "onPlaywordagain"]))
              : (_ctx.mode === _ctx.MODES.quizzIntro)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: "relative flex flex-col h-full bg-no-repeat bg-bottom w-1/3",
                      style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.omarHappyImage + ')' })
                    }, null, 4 /* STYLE */),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t('quizzTitle')), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_Button, {
                            class: "pointer-events-auto bg-white p-2 rounded-full -top-2 -right-2 mb-6",
                            childclass: 'w-12 h-12',
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.soundIsPlaying ? _ctx.stopSounds() : _ctx.playInstruction()))
                          }, {
                            default: _withCtx(() => [
                              (_ctx.soundIsPlaying)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                                : (_openBlock(), _createElementBlock("img", _hoisted_11))
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_Button, {
                            backgroundcolour: 'bg-sl-green-button',
                            textcolour: 'text-white',
                            childclass: 'text-2xl border-none h-16 p-4 inline-block',
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeMode(_ctx.MODES.quizz)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('start')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ])
                      ])
                    ])
                  ]))
                : (_ctx.mode === _ctx.MODES.quizz)
                  ? (_openBlock(), _createBlock(_component_ChaosQuizz, {
                      key: 4,
                      playerwordlists: _ctx.playersAndWords,
                      mindelay: _ctx.question.minDelay,
                      onReplay: _cache[7] || (_cache[7] = ($event: any) => (_ctx.playAgain()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Button, {
                          backgroundcolour: 'bg-sl-green-button',
                          textcolour: 'text-white',
                          childclass: 'text-2xl border-none h-16 w-56',
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeMode(_ctx.MODES.finished)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('done')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["playerwordlists", "mindelay"]))
                  : (_ctx.mode === _ctx.MODES.finished)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: "flex flex-col h-full bg-no-repeat bg-bottom w-1/3",
                          style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.omarHappyImage + ')' })
                        }, null, 4 /* STYLE */),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.t('finishedTitle')), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_Button, {
                              backgroundcolour: 'bg-sl-green-button',
                              textcolour: 'text-white',
                              childclass: 'text-2xl border-none h-16 p-4 inline-block',
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.finish()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('done')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            })
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}